import { gql } from '../../../../../hooks'

export const DELETE_PROTOCOLS = gql`
  mutation AdministrationDeleteComponentProtocols($id: ID!) {
    aDelete(path: "component/protocols", id: $id) {
    }
  }
`

export const LIST_PROTOCOLS = gql`
  query AdministrationListComponentProtocols(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(
      path: "component/protocols"
      filter: $filter
      page: $page
      limit: $limit
    ) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`
